(() => {
  const CHECK = "✔";
  const CROSS = "✖";

  function findFirstTextNode(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.textContent && node.textContent.trim().length
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      },
    });
    return walker.nextNode();
  }

  function processLi(li) {
    if (li.dataset.listIconProcessed === "true") return;

    const textNode = findFirstTextNode(li);
    if (!textNode) {
      li.dataset.listIconProcessed = "true";
      return;
    }

    const raw = textNode.textContent;
    const trimmed = raw.trimStart();

    if (trimmed.startsWith(CHECK)) {
      li.classList.add("li-icon--check");
      // remove leading symbol + optional following spaces
      textNode.textContent = raw.replace(/^\s*✔\s*/, "");
    } else if (trimmed.startsWith(CROSS)) {
      li.classList.add("li-icon--cross");
      textNode.textContent = raw.replace(/^\s*✖\s*/, "");
    }

    li.dataset.listIconProcessed = "true";
  }

  function processAllLists(scope = document) {
    scope.querySelectorAll("li").forEach(processLi);
  }

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => processAllLists());
  } else {
    processAllLists();
  }

  // Handle theme editor / dynamic content / quick view re-renders
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches("li")) processLi(node);
        processAllLists(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
